import { Routes } from '@angular/router';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { OrdersComponent } from './orders/orders.component';

export const OrderRoutingModule: Routes = [
	{ path: 'orders', component: OrdersComponent },
	{ path: 'order-details/:orderId', component: OrderDetailsComponent },
];
